import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.phone || !formData.message) {
      return;
    }

    if (formData.message.length > 500) {
      alert('Pesan tidak boleh lebih dari 500 karakter');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams({
        name: formData.name,
        phone: formData.phone,
        message: formData.message
      }).toString();

      const response = await fetch('https://readdy.ai/api/form/d4hv4altnoqs9bvm9to0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
              Hubungi Kami
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
            Mari Berdiskusi tentang Kebutuhan Anda
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Tim kami siap membantu menjawab pertanyaan dan memberikan solusi terbaik
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-[#0B1F3B] to-[#0d2847] rounded-3xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-6">Informasi Kontak</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FF8A00] rounded-xl flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">Alamat</h4>
                    <p className="text-gray-300">
                      Banjiran Gg. 8 No.12<br />
                      Warungasem – Batang<br />
                      Jawa Tengah, Indonesia
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FF8A00] rounded-xl flex-shrink-0">
                    <i className="ri-whatsapp-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">WhatsApp</h4>
                    <a href="https://wa.me/6285868360910" className="text-gray-300 hover:text-[#FF8A00] transition-colors cursor-pointer">
                      0858-6836-0910
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FF8A00] rounded-xl flex-shrink-0">
                    <i className="ri-map-2-line text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg mb-1">Area Layanan</h4>
                    <p className="text-gray-300">
                      Warungasem, Batang, dan sekitarnya
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-white/20">
                <a
                  href="https://wa.me/6285868360910"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-[#25D366] hover:bg-[#20bd5a] text-white py-4 rounded-xl font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-3 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-2xl"></i>
                  Chat via WhatsApp
                  <i className="ri-arrow-right-line text-xl"></i>
                </a>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-3xl overflow-hidden shadow-lg border border-gray-200">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126646.89276531!2d109.6!3d-6.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e7024c7e8d7c5e5%3A0x5027a76e356a770!2sWarungasem%2C%20Batang%20Regency%2C%20Central%20Java!5e0!3m2!1sen!2sid!4v1234567890"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Lokasi Bastian Digital Service"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-gray-50 rounded-3xl p-8 border border-gray-200">
            <h3 className="text-2xl font-bold text-[#0B1F3B] mb-6">Kirim Pesan</h3>
            
            <form id="contact-form" onSubmit={handleSubmit} className="space-y-6" data-readdy-form>
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                  Nama Lengkap <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all text-sm"
                  placeholder="Masukkan nama Anda"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                  Nomor WhatsApp <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  required
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all text-sm"
                  placeholder="08xx-xxxx-xxxx"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-[#0B1F3B] mb-2">
                  Pesan <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#FF8A00] focus:ring-2 focus:ring-[#FF8A00]/20 outline-none transition-all resize-none text-sm"
                  placeholder="Ceritakan kebutuhan Anda..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">
                  {formData.message.length}/500 karakter
                </p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] hover:from-[#0d2847] hover:to-[#0B1F3B] text-white py-4 rounded-xl font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-3 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line text-xl animate-spin"></i>
                    Mengirim...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-fill text-xl"></i>
                    Kirim Pesan
                  </>
                )}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl flex items-center gap-3">
                  <i className="ri-check-line text-xl"></i>
                  <span className="text-sm">Pesan berhasil dikirim! Kami akan segera menghubungi Anda.</span>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl flex items-center gap-3">
                  <i className="ri-error-warning-line text-xl"></i>
                  <span className="text-sm">Terjadi kesalahan. Silakan coba lagi atau hubungi kami via WhatsApp.</span>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
